import 'reflect-metadata'; // 這行必須在檔案的最頂部，盡早載入
import 'zone.js'; // 確保 zone.js 也在這裡，它是 Angular 核心所需

if (window.global === undefined) {
    window.global = window;
}